import { is45deg } from "~/composables/shapes/utils";

const SHAPE_STROKE_BASE = 1.5;

const INVERT_SIZE_SHAPES = [
  "ShiplapVertical",
  "MiniShiplapVertical",
  "ShiplapVertical45deg",
  "MiniShiplapVertical45deg",
  "LargeHalfCircleHorizontalFlipped",
  "HalfCircleHorizontalFlipped",
  "LargeHalfCircleHorizontal",
  "HalfCircleHorizontal",
];

const SCALE_SHAPES = [
  "ShiplapVertical",
  "MiniShiplapVertical",
  "LargeHalfCircleVertical",
  "LargeHalfCircleHorizontal",
  "LargeHalfCircleVerticalFlipped",
  "LargeHalfCircleHorizontalFlipped",
  "HalfCircleVertical",
  "HalfCircleHorizontal",
  "HalfCircleVerticalFlipped",
  "HalfCircleHorizontalFlipped",
  "HexSpaced",
];

export function getShapeIconSize(
  shape: any,
  gridPatternId: string,
  scale = 3.43,
  unit = "px",
) {
  const maxSize = gridPatternId === "3d" ? "104px" : "70px";
  let max = { maxWidth: maxSize, maxHeight: maxSize };
  const f = (x: number) => Math.round(x / scale) + unit;
  let sizes = { height: f(shape.h), width: f(shape.w) };

  if (INVERT_SIZE_SHAPES.includes(shape.id)) {
    sizes = { height: f(shape.w), width: f(shape.h) };
  }
  if (shape.prefix === "SmallHalfCircle") {
    sizes = { height: f(120), width: f(60) };
  }
  if (is45deg(shape.rotation)) {
    scale = 3;
    const size = Math.max(shape.w, shape.h);
    const f2 = (x: number) => Math.round(x / scale) + unit;
    sizes = { height: f2(size), width: f2(size * 0.7) };
    max = { maxWidth: "80px", maxHeight: "80px" };
  }
  return { ...max, ...sizes };
}

export function getSVGStyle(shape: any) {
  let transform = shape.rotation ? `rotate(${shape.rotation}deg)` : "";
  const style: Record<string, string> = {
    width: "inherit",
    height: "inherit",
    marginBottom: "6px",
    transformOrigin: "center center",
  };
  let cssScale = 1;
  if (SCALE_SHAPES.includes(shape.id)) {
    cssScale = Math.max(shape.w / shape.h, shape.h / shape.w);
    transform += `scale(${cssScale})`;
  }
  const iconSize = Math.min(Math.max(shape.w, shape.h) / 3.43, 70);
  style["--shape-stroke"] =
    `${(SHAPE_STROKE_BASE * Math.pow(iconSize / 70, 0.25)) / cssScale}px`;
  return { ...style, transform };
}

export function getSVGClass(shape: any) {
  return shape.icon && shape.icon.startsWith("Engraved")
    ? ""
    : "shape-stroke-normalized";
}

export function getShapeTooltipPositionClass(shape: any) {
  return shape.menuAlign === "right"
    ? "right-0 left-auto translate-x-0"
    : "left-1/2 -translate-x-1/2";
}
